var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"railway-control__content-header__calendar-item"},[(_vm.isActive)?_c('r-text',[_vm._v(" "+_vm._s(_vm.getActiveDate)+" ")]):_vm._e(),(!_vm.isActive)?_c('r-text',{attrs:{"type":"caption"}},[_vm._v(" "+_vm._s(_vm.getDay)+" ")]):_vm._e(),(!_vm.isActive)?_c('r-text',[_vm._v(" "+_vm._s(_vm.getDate)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }